/**
 * View component for /user-evaluations/new
 *
 * Creates a new userEvaluation from a copy of the defaultItem in the userEvaluation reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { history, withRouter } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as userEvaluationActions from '../userEvaluationActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import userEvaluation components
import UserEvaluationForm from '../components/UserEvaluationForm.js.jsx';
import UserEvaluationLayout from '../components/UserEvaluationLayout.js.jsx';

class CreateUserEvaluation extends Base {
  constructor(props) {
    super(props);
    this.state = {
      userEvaluation: _.cloneDeep(this.props.defaultUserEvaluation)
      // NOTE: We don't want to actually change the store's defaultItem, just use a copy
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
    );
  }

  _handleFormChange(e) {
    /**
     * This let's us change arbitrarily nested objects with one pass
     */
    let newUserEvaluationState = _.update( this.state.userEvaluation, e.target.name, function() {
      return e.target.value;
    });
    this.setState({userEvaluation :newUserEvaluationState});
  }


  _handleFormSubmit(e) {
    const { dispatch, history } = this.props;
    e.preventDefault();
    dispatch(userEvaluationActions.sendCreateUserEvaluation(this.state.userEvaluation)).then((action) => {
      if(action.success) {
        dispatch(userEvaluationActions.invalidateList());
        history.push(`/user-evaluations/${action.item._id}`)
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert("ERROR - Check logs");
      }
    });
  }

  render() {
    const { userEvaluation } = this.state;
    const isEmpty = (userEvaluation.name === null || userEvaluation.name === undefined);
    return (
      <UserEvaluationLayout>
        <div className="flex">
          <section className="section">
            {isEmpty ?
              <h2> Loading...</h2>
              :
              <UserEvaluationForm
                userEvaluation={userEvaluation}
                cancelLink="/user-evaluations"
                formTitle="Create User Evaluation"
                formType="create"
                handleFormChange={this._handleFormChange}
                handleFormSubmit={this._handleFormSubmit}
                />
            }
          </section>
        </div>
      </UserEvaluationLayout>
    )
  }
}

CreateUserEvaluation.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    defaultUserEvaluation: store.userEvaluation.defaultItem
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(CreateUserEvaluation)
);



// WEBPACK FOOTER //
// modules/userEvaluation/views/CreateUserEvaluation.js.jsx